import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=4be3b068&scoped=true&"
import script from "./approvalDetail.vue?vue&type=script&lang=ts&"
export * from "./approvalDetail.vue?vue&type=script&lang=ts&"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&id=4be3b068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3b068",
  null
  
)

export default component.exports